// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.calendars-route .calendar-row {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  position: relative;
}
.calendars-route .calendar-row .color-arrow {
  flex: 0 0 1.5rem;
  cursor: pointer;
  padding: 0 0 0 0.5rem;
  text-align: right;
  font-size: 2rem;
  line-height: 2rem;
  background: none;
  border: none;
  color: #e7e7e7;
}
.calendars-route .calendar-row .color-arrow:hover {
  color: #555;
}
.calendars-route .calendar-row .color-arrow:focus {
  outline: revert;
}
.calendars-route .calendar-row .calendar-name {
  flex: 0 0 calc(100% - 4rem);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.calendars-route .calendar-row .calendar-color {
  flex: 0 0 2rem;
  height: 2rem;
  vertical-align: super;
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 2rem;
  line-height: 2rem;
  border: 0.1rem solid #333;
  border-radius: 0.5rem;
  background: none;
  padding: 0;
}
.calendars-route .calendar-row .calendar-color:focus {
  outline: revert;
}
@media (max-width: 768px) {
  .calendars-route .calendar-row {
    height: 3.6rem;
  }
  .calendars-route .calendar-row .color-arrow,
  .calendars-route .calendar-row .calendar-color {
    font-size: 3rem;
  }
  .calendars-route .calendar-row .calendar-color {
    flex: 0 0 2.5rem;
    height: 2.5rem;
  }
  .calendars-route .calendar-row .calendar-name {
    flex: 0 0 calc(100% - 5rem);
  }
}
.calendars-route .calendar-route-action-btn {
  display: block;
  width: 100%;
  padding: 0.3rem 1rem;
  background: none;
  border: none;
  text-align: left;
  font: inherit;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}
.calendars-route .calendar-route-action-btn:hover {
  background-color: #f5f5f5;
  color: #262626;
}
.calendars-route .calendar-route-action-btn:focus {
  outline: revert;
}
.calendars-route .color-picker-wrapper .picker {
  z-index: 200;
}
@media (min-width: 768px) {
  .calendars-route .color-picker-wrapper .picker {
    top: 2.5rem;
    right: -22.1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationNavigation/RouteSections/Calendars/CalendarRoute.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AAAI;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EAEA,cAAA;AACN;AAAM;EACE,WAAA;AAER;AAAM;EACE,eAAA;AAER;AACI;EACE,2BAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AACN;AAEI;EACE,cAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;AADN;AAGM;EACE,eAAA;AADR;AAKI;EApDF;IAqDI,cAAA;EAFJ;EAGI;;IAEE,eAAA;EADN;EAII;IACE,gBAAA;IACA,cAAA;EAFN;EAKI;IACE,2BAAA;EAHN;AACF;AAOE;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AALJ;AAOI;EACE,yBAAA;EACA,cAAA;AALN;AAQI;EACE,eAAA;AANN;AAUE;EACE,YCnEe;AD2DnB;AASI;EAFF;IAGI,WAAA;IACA,eAAA;EANJ;AACF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n.calendars-route {\n  .calendar-row {\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    position: relative;\n\n    .color-arrow {\n      flex: 0 0 1.5rem;\n      cursor: pointer;\n      padding: 0 0 0 0.5rem;\n      text-align: right;\n      font-size: 2rem;\n      line-height: 2rem;\n      background: none;\n      border: none;\n\n      color: #e7e7e7;\n      &:hover {\n        color: #555;\n      }\n      &:focus {\n        outline: revert;\n      }\n    }\n    .calendar-name {\n      flex: 0 0 calc(100% - 4rem);\n      display: inline-block;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      cursor: pointer;\n    }\n\n    .calendar-color {\n      flex: 0 0 2rem;\n      height: 2rem;\n      vertical-align: super;\n      margin-right: 0.5rem;\n      cursor: pointer;\n      font-size: 2rem;\n      line-height: 2rem;\n\n      border: 0.1rem solid #333;\n      border-radius: 0.5rem;\n      background: none;\n      padding: 0;\n\n      &:focus {\n        outline: revert;\n      }\n    }\n\n    @media (max-width: $tablet) {\n      height: 3.6rem;\n      .color-arrow,\n      .calendar-color {\n        font-size: 3rem;\n      }\n\n      .calendar-color {\n        flex: 0 0 2.5rem;\n        height: 2.5rem;\n      }\n\n      .calendar-name {\n        flex: 0 0 calc(100% - 5rem);\n      }\n    }\n  }\n\n  .calendar-route-action-btn {\n    display: block;\n    width: 100%;\n    padding: 0.3rem 1rem;\n    background: none;\n    border: none;\n    text-align: left;\n    font: inherit;\n    color: #333;\n    cursor: pointer;\n    white-space: nowrap;\n\n    &:hover {\n      background-color: #f5f5f5;\n      color: #262626;\n    }\n\n    &:focus {\n      outline: revert;\n    }\n  }\n\n  .color-picker-wrapper .picker {\n    z-index: $colorPickerLayer;\n    @media (min-width: $tablet) {\n      top: 2.5rem;\n      right: -22.1rem;\n    }\n  }\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
